import { render, staticRenderFns } from "./ThirdSectionItem.vue?vue&type=template&id=88012950&"
import script from "./ThirdSectionItem.vue?vue&type=script&lang=js&"
export * from "./ThirdSectionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports